import * as React from 'react';

import { Button as CBButton, ButtonProps } from '@creditornot/cb-button';

import { PartialBy } from '../../types';

type Props = PartialBy<ButtonProps, 'size' | 'variant'>;

/**
 * Identical to the Cookbook `Button` component, but with default values for props.
 */
export const Button = (props: Props): React.ReactElement => (
  <CBButton size="small" variant="secondary" {...props} />
);
